// extracted by mini-css-extract-plugin
export default {"productGallery":"Bw-z","infoAboveGallery":"Cw-z","inQuickShop":"Dw-z"};